const OliviaLogo = require("./OliviaLogoColor.png");

export { OliviaLogo };
